import { useRef, useState, useEffect } from 'react';

function useIntersectionObserver(ref, options) {
  const stableOptions = useRef(options);
  const [isIntersecting, setIntersecting] = useState(false);
  stableOptions.current = options;
  useEffect(() => {
    const target = ref.current;
    if (!target) {
      return;
    }
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      if (!entry) {
        return;
      }
      setIntersecting(entry.isIntersecting);
      if (entry.isIntersecting && options?.once) {
        observer.disconnect();
      }
    }, stableOptions.current);
    observer.observe(target);
    return () => {
      observer.disconnect();
    };
  }, [options?.once, ref]);
  return isIntersecting;
}

export { useIntersectionObserver };
//# sourceMappingURL=intersection-observer.js.map
